import HELPER from '@/app/utils/HELPER';

/**
 * HOT FIX: add attribute "data-group" module or element
 */
import { AtomGroup } from '../editor/iframe/atom/Atom.model';

export const GroupLabelMap: Partial<Record<AtomGroup, string[]>> = {};

GroupLabelMap[AtomGroup.ChildProduct] = [
  '(P) File Upload',
  '(P) Vendor',
  '(P) SKU',
  '(P) Ali Reviews',
  '(P) Dynamic Checkout Button',
  '(P) Title',
  '(P) Description',
  '(P) Price',
  '(P) Quantity',
  '(P) Stock Counter',
  '(P) Cart Button',
  '(P) View More',
  '(P) Image',
  '(P) Image List',
  '(P) Variants',
  '(P) Swatches',
  '(P) Meta',
  'Bold Product Options',
  'Bold Subscriptions',
  'Recharge Subscription',
  'Infinite Options',
  'Seal Subscriptions',
];

GroupLabelMap[AtomGroup.ChildArticle] = ['(A) Title', '(A) Image', '(A) Content', '(A) Excerpt', '(A) Date'];

GroupLabelMap[AtomGroup.Product] = ['Product'];

GroupLabelMap[AtomGroup.ChildProductAndProductPage] = [];

GroupLabelMap[AtomGroup.Article] = ['Article'];

GroupLabelMap[AtomGroup.ProductList] = ['Product List', 'Related Products'];

GroupLabelMap[AtomGroup.ArticleList] = ['Article List', 'PickyStory'];

GroupLabelMap[AtomGroup.ChildCollection] = [
  'Collection Toolbar',
  'Paginator',
  'Collection Banner',
  'Collection Title',
  'Collection Desc',
];

GroupLabelMap[AtomGroup.ThirdParties] = [
  'Judge.me Reviews',
  'Product Reviews',
  'Appstle Subscriptions',
  'Yotpo - Product & Collection Page',
  'Rivyo Reviews',
  'Stamped.io - Product & Collection Page',
  'Ryviu',
  'Ultimate Sales Boost',
  'WideBundle',
  'Opinew - Product & Collection Pages',
  'Ryviu: Product Review App',
  'Wiser - Product & Collection Page',
  'Trustoo',
  'Kaching Bundle Quantity Breaks',
];

/**
 * findGroupByLabel
 * @param label label
 * @returns Atom group
 */
function findGroupByLabel(label: string): AtomGroup {
  for (const group in GroupLabelMap) {
    const labelsArray = GroupLabelMap[group as AtomGroup] as string[];
    if (labelsArray.includes(label)) {
      return group as AtomGroup;
    }
  }
  return AtomGroup.Module;
}

/**
 * HOT FIX: add attribute "data-group" module or element
 * @param $snippet $snippet
 * @returns group
 */
export function addModuleGroupJquery($snippet: JQuery): AtomGroup {
  let group = $snippet.attr('data-atomgroup') as AtomGroup | undefined;
  if (group) {
    return group;
  }
  const label = $snippet.attr('data-label') as string;
  group = findGroupByLabel(label);
  $snippet.attr('data-atomgroup', group);
  return group;
}

/**
 * checkOutsideProduct
 * @param options options
 * @param $to $to
 * @returns right
 */
export function checkOutsideProduct($to: JQuery, options: any): boolean {
  const $from = options.$from as JQuery;
  if ($from.closest('[data-label="Product"]').length > 0 && $to.closest('[data-label="Product"]').length == 0) {
    HELPER.showNotify('This field is dropped to Product only.', 'error');
    return false;
  }
  return true;
}

/**
 * checkOutsideArticle
 * @param options options
 * @param $to $to
 * @returns right
 */
export function checkOutsideArticle($to: JQuery, options: any): boolean {
  const $from = options.$from as JQuery;
  if ($from.closest('[data-label="Article"]').length > 0 && $to.closest('[data-label="Article"]').length == 0) {
    HELPER.showNotify('This field is dropped to Article only.', 'error');
    return false;
  }
  return true;
}

/**
 * warningList
 * @param options options
 * @param $to $to
 * @returns right
 */
export function checkProductInProductOrList($to: JQuery): boolean {
  if ($to.closest('[data-label="Product"]').length > 0) {
    HELPER.showNotify('Cannot put a product inside a product.', 'error');
    return false;
  } else if (HELPER.isInsideTheList($to)) {
    HELPER.showNotify('Cannot put a product inside a list.', 'error');
    return false;
  }
  return true;
}

/**
 * warningList
 * @param options options
 * @param $to $to
 * @returns right
 */
export function checkChildProductAndProductPage($to: JQuery, options: any): boolean {
  const $from = options.$from as JQuery;
  const pageType = options.pageType as string;
  if (
    pageType != 'template-product' &&
    $from.closest('[data-label="Product"]').length > 0 &&
    $to.closest('[data-label="Product"]').length == 0
  ) {
    HELPER.showNotify('This module is not linked to any product.', 'error');
    return false;
  }
  return true;
}
/**
 * warningList
 * @param options options
 * @param $to $to
 * @returns right
 */
export function checkArticleInArticleOrList($to: JQuery): boolean {
  if ($to.closest('[data-label="Article"]').length > 0) {
    HELPER.showNotify('Cannot put a article inside a product.', 'error');
    return false;
  } else if (HELPER.isInsideTheList($to)) {
    HELPER.showNotify('Cannot put a product inside a list.', 'error');
    return false;
  }
  return true;
}

/**
 * warningProduct
 * @param options options
 * @param $to $to
 * @returns right
 */
export function checkList($to: JQuery, options: any): boolean {
  if ($to.closest('[data-label="Product"]').length > 0) {
    const moduleName = options.moduleName as string;
    HELPER.showNotify(`Cannot put a ${moduleName} inside a Product.`, 'error');
    return false;
  } else if ($to.closest('[data-label="Article"]').length > 0) {
    HELPER.showNotify('Cannot put a list inside a article.', 'error');
    return false;
  } else if (HELPER.isInsideTheList($to)) {
    HELPER.showNotify('Cannot put a list inside another list.', 'error');
    return false;
  }
  return true;
}

/**
 * warningProduct
 * @param options options
 * @param $to $to
 * @returns right
 */
export function checkChildCollection($to: JQuery, options: any): boolean {
  const moduleName = options.moduleName as string;
  if (HELPER.isInsideTheList($to)) {
    HELPER.showNotify(`Cannot put a ${moduleName} inside a Product List.`, 'error');
  }
  return true;
}

/**
 * warningProduct
 * @param options options
 * @param $to $to
 * @returns right
 */
export function checkThirdParties($to: JQuery, options: any): boolean {
  const $from = options.$from as JQuery;
  const pageType = options.pageType as string;
  const moduleName = options.moduleName as string;
  if (
    pageType != 'template-product' &&
    $from.closest('[data-label="Product"]').length > 0 &&
    $to.closest('[data-label="Product"]').length == 0
  ) {
    HELPER.showNotify(`Cannot put a ${moduleName} inside a Product.`, 'error', 3000);
    return false;
  }
  return true;
}

/**
 * warningProduct
 * @param options options
 * @param $to $to
 * @returns right
 */
export function defaultCheckChildOutsideParent($to: JQuery, options: any): boolean {
  const $from = options.$from as JQuery;
  const $stElement = options.$stElement as JQuery;
  if ($stElement && $from.closest('[data-label="Product"]').length > 0) {
    const $moduleElmProduct = $stElement.find(`[data-atomproduct="${AtomGroup.ChildProduct}"]`);
    if ($moduleElmProduct.length > 0) {
      if ($to.closest('[data-label="Product"]').length == 0) {
        HELPER.showNotify('You cannot move product child elements out of Product.', 'error');
        return false;
      } else if (HELPER.isInsideTheList($to)) {
        HELPER.showNotify('You cannot move product child elements out of Product.', 'error');
        return false;
      }
    }
  }
  if ($stElement && $from.closest('[data-label="Article"]').length > 0) {
    const $moduleElmArticle = $stElement.find(`[data-atomproduct="${AtomGroup.ChildArticle}"]`);
    if ($moduleElmArticle.length > 0) {
      if ($to.closest('[data-label="Article"]').length == 0) {
        HELPER.showNotify('This module contains only fields that exist in the article', 'error');
        return false;
      } else if (HELPER.isInsideTheList($to)) {
        HELPER.showNotify('This module contains only fields that exist in the article', 'error');
        return false;
      }
    }
  }
  return true;
}

export type CheckAtomGroupFunction = ($to: JQuery, options?: any) => boolean;

export const CheckAtomGroupMap: Partial<Record<AtomGroup, CheckAtomGroupFunction>> = {};
CheckAtomGroupMap[AtomGroup.ChildProduct] = checkOutsideProduct;
CheckAtomGroupMap[AtomGroup.Product] = checkProductInProductOrList;
CheckAtomGroupMap[AtomGroup.ChildProductAndProductPage] = checkChildProductAndProductPage;
CheckAtomGroupMap[AtomGroup.Article] = checkArticleInArticleOrList;
CheckAtomGroupMap[AtomGroup.ProductList] = checkList;
CheckAtomGroupMap[AtomGroup.ArticleList] = checkList;
CheckAtomGroupMap[AtomGroup.ChildCollection] = checkChildCollection;
CheckAtomGroupMap[AtomGroup.ThirdParties] = checkThirdParties;
CheckAtomGroupMap[AtomGroup.Module] = defaultCheckChildOutsideParent;
